<template>
  <div>
    <section>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="allName" name="all">
        <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
          <el-form :inline="true" :model="allCondition">
            <el-form-item class="form-class">
              <el-input v-model="allCondition.couponName" placeholder="用户名" clearable></el-input>
            </el-form-item>
            <el-form-item class="form-class">
              <el-button type="primary" v-on:click="getAllFilterList">查询</el-button>
            </el-form-item >
            <el-form-item class="form-class">
              <el-button type="default" @click="resetAll()">重置</el-button>
            </el-form-item >
            <el-form-item class="form-class">
              <el-select v-model="allCondition.couponType" placeholder="请选择" @change="verifyChanged">
                <el-option
                  v-for="item in CouponTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form-class">
              <el-select v-model="allCondition.orderType" placeholder="请选择" @change="verifyChanged">
                <el-option
                  v-for="item in allOrderOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-table ref="allTable" stripe align="left" :data="allTableDate" highlight-current-row v-loading="allLoading"
                  style="width: 100%;">
            <el-table-column  type="selection"  width="55"></el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" 
                      min-width="40%"></el-table-column>
            <el-table-column align="center" prop="couponName" label="卡券名称" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="merchantName" label="发券商户" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="couponType" label="卡券类型" :formatter="formatCouponType" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="checkStatus" label="状态" :formatter="formatCheckStatus" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="banlanceCount" label="库存" min-width="20%"></el-table-column>
            <el-table-column align="center"  label="领取" min-width="20%">
              <template slot-scope="scope">
                <el-button type="text"  @click="handleCouponCollection(scope.$index, scope.row)">{{scope.row.getNum}}</el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="couponStatus" label="核销" min-width="20%">
              <template slot-scope="scope">
                <el-button type="text"  @click="handleCheckCoupon(scope.$index, scope.row)">{{scope.row.useNum}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" class="button-bar" fixed='right' align="center">
              <template slot-scope="scope">
                <el-button type="text"  size="small" @click="handleCouponDetail(scope.$index, scope.row)">卡券详情</el-button>
                <el-button type="text"  size="small" @click="showTransferCoupon(scope.$index, scope.row)">卡券转移</el-button>
              </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24" style="margin-top:10px">
              <el-button type="primary" @click="audit()">审核通过</el-button>
              <el-button type="default" @click="failAudit()">审核不通过</el-button>
              <!-- <el-button type="primary" @click="showHot()">热门显示</el-button>
              <el-button type="default" @click="hideHot()">热门隐藏</el-button> -->
          </el-col>
        </el-row>
        <el-col :span="24" class="toolbar" style="margin-top:10px;">
          <el-pagination
            @size-change="handleAllSizeChange"
            @current-change="handleAllCurrentChange"
            :current-page=allCurrentPage
            :page-sizes="[10, 20, 30, 40]"
            :page-size=allPageSize
            layout="total, sizes, prev, pager, next, jumper"
            :total=allTotal>
          </el-pagination>
        </el-col>
      </el-tab-pane>
      <el-tab-pane :label="examineName" name="examine">
        <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
          <el-form :inline="true" :model="examineCondition">
            <el-form-item class="form-class">
              <el-input v-model="examineCondition.couponName" placeholder="用户名" clearable></el-input>
            </el-form-item>
            <el-form-item class="form-class">
              <el-button type="primary" v-on:click="getExamineFilterList">查询</el-button>
            </el-form-item >
            <el-form-item class="form-class">
              <el-button type="default" >重置</el-button>
            </el-form-item >
            <el-form-item class="form-class">
              <el-select  v-model="examineCondition.couponType" placeholder="请选择" @change="verifyChanged">
                <el-option
                  v-for="item in CouponTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form-class">
              <el-select  v-model="examineCondition.orderType" placeholder="请选择" @change="verifyChanged">
                <el-option
                  v-for="item in allOrderOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
          <el-table ref="examineTable" stripe align="left" :data="examineTableDate" highlight-current-row v-loading="examineLoading"
                  style="width: 100%;">
            <el-table-column  type="selection"  width="55"></el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" :formatter="formatTime"
                      min-width="40%"></el-table-column>
            <el-table-column align="center" prop="couponName" label="卡券名称" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="merchantName" label="发券商户" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="couponType" label="卡券类型" :formatter="formatCouponType" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="checkStatus" label="状态" :formatter="formatCheckStatus" min-width="20%"></el-table-column>
            <el-table-column label="操作" width="120" class="button-bar" fixed='right'>
              <template slot-scope="scope">
                <el-button type="text"  size="small" @click="handleCouponDetail(scope.$index, scope.row)">卡券详情</el-button>
              </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" style="margin-top:10px">
            <el-button type="primary" @click="examineAudit()">审核通过</el-button>
            <el-button type="default" @click="examineFailAudit()">审核不通过</el-button>
        </el-col>
        <el-col :span="24" class="toolbar" style="margin-top:10px;">
          <el-pagination
            @size-change="handleExamineSizeChange"
            @current-change="handleExamineCurrentChange"
            :current-page=examineCurrentPage
            :page-sizes="[10, 20, 30, 40]"
            :page-size=examinePageSize
            layout="total, sizes, prev, pager, next, jumper"
            :total=examineTotal>
          </el-pagination>
        </el-col>
      </el-tab-pane>
      <el-tab-pane :label="trusteeshipName" name="trusteeship">
        <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
          <el-form :inline="true" :model="truCondition">
            <el-form-item class="form-class">
              <el-input v-model="truCondition.couponName" placeholder="用户名" clearable></el-input>
            </el-form-item>
            <el-form-item class="form-class">
              <el-button type="primary" v-on:click="getTruFilterList">查询</el-button>
            </el-form-item >
            <el-form-item class="form-class">
              <el-button type="default" >重置</el-button>
            </el-form-item >
            <el-form-item class="form-class">
              <el-select v-model="truCondition.couponType" placeholder="请选择" @change="verifyChanged">
                <el-option
                  v-for="item in CouponTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form-class">
              <el-select v-model="truCondition.orderType" placeholder="请选择" @change="verifyChanged">
                <el-option
                  v-for="item in allOrderOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-table ref="truTable" stripe align="left" :data="truTableDate" highlight-current-row v-loading="truLoading"
                  style="width: 100%;">
            <el-table-column  type="selection"  width="55"></el-table-column>
            <el-table-column align="center" prop="createTime" label="创建时间" :formatter="formatTime"
                      min-width="40%"></el-table-column>
            <el-table-column align="center" prop="couponName" label="卡券名称" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="merchantName" label="发券商户" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="couponType" label="卡券类型" :formatter="formatCouponType" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="statusView" label="状态"  min-width="20%"></el-table-column>
              <el-table-column align="center" prop="hotFlg" label="热门" :formatter="formatHotFlg" min-width="20%"></el-table-column>
            <el-table-column align="center" prop="banlanceCount" label="库存" min-width="20%"></el-table-column>
            <el-table-column align="center"  label="领取" min-width="20%">
              <template slot-scope="scope">
                <el-button type="text"  @click="handleCouponCollection(scope.$index, scope.row)">{{scope.row.getNum}}</el-button>
              </template>
            </el-table-column>
            <el-table-column align="center"  label="核销" min-width="20%">
              <template slot-scope="scope">
                <el-button type="text"  @click="handleCheckCoupon(scope.$index, scope.row)">{{scope.row.useNum}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" class="button-bar" fixed='right'>
              <template slot-scope="scope">
                <el-button type="text"  size="small" @click="handleCouponDetail(scope.$index, scope.row)">卡券详情</el-button>
              </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" style="margin-top:10px">
            <el-button type="primary" @click="truShowHot()">热门显示</el-button>
            <el-button type="default" @click="truHideHot()">热门隐藏</el-button>
        </el-col>
        <el-col :span="24" class="toolbar">
          <el-pagination 
            @size-change="handleTruSizeChange"
            @current-change="handleTruCurrentChange"
            :current-page=truCurrentPage
            :page-sizes="[10, 20, 30, 40]"
            :page-size=truPageSize
            layout="total, sizes, prev, pager, next, jumper"
            :total=truTotal>
          </el-pagination>
        </el-col>

      </el-tab-pane>
    </el-tabs>

    <Dialog  v-if="isShow" :propsData="propsData" ref="dia" @fatherMethod="getList()"></Dialog>
    </section>
    <el-dialog
      title="卡券转移"
      :visible.sync="showTransfer"
      width="30%"
      >
      <el-form :model="couponInfo" label-width="150px">
        <el-form-item label="转移卡券信息："></el-form-item>
        <el-form-item label="卡券名称">
          <el-input v-model="couponInfo.couponName" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="发券商户">
          <el-input v-model="couponInfo.merchantName" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="接收者id">
          <el-input v-model="acceptUserId" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="showTransfer=false">取消</el-button>
          <el-button type="primary" @click="transferCoupon(couponInfo)">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
   import {CouponOptions} from '../details/detail-data.js'
  import Dialog  from '../coupon/couponDetail.vue'
  export default {
    name: "coupon",
    components: {
      Dialog
    },
    data() {
      return {
        activeName:'all',
        allName:"全部",
        examineName:"审核",
        trusteeshipName:"运营托管",

        allTableDate:[],
        allLoading:false,
        allCurrentPage: 0,
        allPageSize: 10,
        allTotal:0,
        allCondition:{
            couponName:"",
            couponType:"",
            orderType:""
        },

        examineTableDate:[],
        examineLoading:false,
        examineCurrentPage: 0,
        examinePageSize: 10,
        examineTotal:10,
        examineCondition:{
            couponName:"",
            couponType:"",
            orderType:""
        },

        truTableDate:[],
        truLoading:false,
        truCurrentPage: 0,
        truPageSize: 10,
        truTotal:0,
        truCondition:{
            couponName:"",
            couponType:"",
            orderType:""
        },


        isShow:false,


        values: [],
        options: CouponOptions.data,
        create_end_date: '结束日期',
        create_start_date: '开始日期',
        tableDate: null,
        listLoading: false,
        totalAmount: 0,
        userId: null,
        userName: '',
        avatar:null,
        currentPage: 0,
        pageSize: 10,
        total: 0,
        timeInterval: '',
        CouponTypes:[{ label: '全部', value: 0 }, { label: '代金券', value: 1 }, { label: '免单卡', value: 2 }],
        allOrderOptions:[ { label: '综合排序', value: '0' },
                          { label: '库存数量', value: '1' },
                          { label: '领取数量', value: '2' },
                          { label: '核销数量', value: '3' },
                          { label: '创建时间', value: '4' },
                          ],
        checkStatuss:[{ label: '未审核', value: 1 }, { label: '审核未通过', value: 2 }, { label: '审核通过', value: 3 }],
        propsData:{},
        hotFlags:[{ label: '-', value: 0 }, { label: '显示', value: 1 }],
        showTransfer: false,
        couponInfo: {},
        acceptUserId: ''
      }
    },
    created() {
      this.getCouponListHeader();
      this.getAllFilterList();
      this.getExamineFilterList();
      this.getTruFilterList();
      
    },
    methods: {
      formatTime(row, column) {
        if (!row.createTime) {
          return '';
        }
        return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
      },
      formatCouponType(row, column){
        let temp = this.CouponTypes.filter((item) => {
					return item.value == row.couponType;
				})
				return temp[0].label;
      },
      formatCheckStatus(row, column){
        let temp = this.checkStatuss.filter((item) => {
					return item.value == row.checkStatus;
				})
				return temp[0].label;
      },
      formatHotFlg(row, column){
        let temp = this.hotFlags.filter((item) => {
					return item.value == row.hotFlag;
				})
				return temp[0].label;
      },
      handleClick(tab, event){
        if(this.activeName =='all' ){
          this.getAllList(0);
        } else if(this.activeName =='examine'){
          this.getExamineList(0);
        } else if(this.activeName =='trusteeship'){
          this.getTruList(0);
        }
      },
      //全部
      getAllFilterList(){
        this.allCurrentPage = 1;
				this.getAllList(this.allCurrentPage);
      },
      handleAllSizeChange(val){
        this.allPageSize = val;
				this.allCurrentPage = 1;
				this.getAllList(this.allCurrentPage);
      },
      handleAllCurrentChange(val) {
        debugger
				this.allCurrentPage = val;
				this.getAllList(this.allCurrentPage);
      },
      async getAllList(index) {
				try{
          this.allCondition.currentPage = index;
          this.allCondition.pageSize = this.allPageSize;
          this.allCondition.checkStatus = 0;
					this.allLoading = true;
					let result = await this.$http.post(this,'/coupon/getAllCouponList', {},this.allCondition);
					if (result && result.code == 200) {
            debugger
						this.allTableDate = result.data.rows;
						this.allTotal = result.data.total;
						this.allLoading = false;
					}
				} catch(e){
					this.allLoading = false;
				}
			},
      resetAll(){
           this.allCondition.couponName='';
           this.allCondition.orderType="";
           this.allCondition.couponType= "";
      },
      //审核
      getExamineFilterList(){
        this.examineCurrentPage = 1;
				this.getExamineList(this.examineCurrentPage);
      },
      handleExamineSizeChange(val){
        this.examinePageSize = val;
				this.examineCurrentPage = 1;
				this.getExamineList(this.examineCurrentPage);
      },
      handleExamineCurrentChange(val) {
				this.examineCurrentPage = val;
				this.getExamineList(this.examineCurrentPage);
      },
      async getExamineList(index) {
				try{
          this.examineCondition.currentPage = index;
          this.examineCondition.pageSize = this.examinePageSize;
          this.examineCondition.checkStatus = -1;
					this.examineLoading = true;
					let result = await this.$http.post(this,'/coupon/getAllCouponList', {},this.examineCondition);
					if (result && result.code == 200) {
						this.examineTableDate = result.data.rows;
						this.examineTotal = result.data.total
						this.examineLoading = false;
					}
				} catch(e){
					this.examineLoading = false;
				}
			},

      //托管
      getTruFilterList(){
        this.truCurrentPage = 1;
				this.getTruList(this.truCurrentPage);
      },
      handleTruSizeChange(val){
        this.truPageSize = val;
				this.truCurrentPage = 1;
				this.getTruList(this.truCurrentPage);
      },
      handleTruCurrentChange(val) {
				this.truCurrentPage = val;
				this.getTruList(this.truCurrentPage);
      },
      async getTruList(index) {
				try{
          this.truCondition.currentPage = index;
          this.truCondition.pageSize = this.truPageSize ;
          this.truCondition.escrowFlag = 1 ;
					this.truLoading = true;
					let result = await this.$http.post(this,'/coupon/getAllCouponList', {},this.truCondition);
					if (result && result.code == 200) {
            
						this.truTableDate = result.data.rows;
						this.truTotal = result.data.total
						this.truLoading = false;
					}
				} catch(e){
					this.examineLoading = false;
				}
			},
      //领取列表
      handleCouponCollection(index,row){
          this.$router.push({ path: '/couponList/getCouponCollection', query: { couponId: row.couponId,shopName:row.merchantName,couponName:row.couponName,avatar:this.avatar,getNum:row.getNum} });
      },
      handleCheckCoupon(index,row){
          this.$router.push({ path: '/couponList/checkCoupon', query: { couponId: row.couponId,shopName:row.merchantName,couponName:row.couponName,avatar:this.avatar,useNum:row.useNum}});
      },

      handleCouponDetail(index,row){
        this.propsData ={};
        this.propsData.userId =  this.userId;
        this.propsData.couponId = row.couponId;
        
        this.isShow =true;
        //this.$router.push({ path: '/operateManage/details', query: { userId: row.id,userName: row.nickName } });
      },
      showTransferCoupon(index, row){
        console.log(this.allTableDate);
        this.showTransfer = true
        this.couponInfo = row
      },
      transferCoupon(){
        let param = {
          acceptUser: this.acceptUserId,
          couponId: this.couponInfo.couponId
        }
        this.$http.post(this,'/coupon/transferCoupon',param, {}).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.data.errorInfo,
              type: "success"
            })
            this.showTransfer = false
          } else {
            this.$message({
              message: '转移失败，请联系开发人员。',
              type: "error"
            })
          }
        });
      },
      async getCouponListHeader(){
        try{
					let result = await this.$http.post(this,'/coupon/getCouponListHeader', {},{});
					if (result && result.code == 200) {
              this.allName = "全部（" + result.data.obj.allCount +"）";
              this.examineName = "审核（" + result.data.obj.checkCount +"）";
              this.trusteeshipName = "运营托管（" + result.data.obj.escrowCount +"）";
					}
				} catch(e){
            console.info('1');
				}
      },
      verifyChanged(){

      },
      async audit (){
          let currentSelect = this.$refs.allTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.checkStatus = 3;
              
              let result = await this.$http.post(this,'/coupon/checkCouponInfo', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getAllList(0);
					    }
          }
      },
      async failAudit(){
          let currentSelect = this.$refs.allTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.checkStatus = 2;
              let result = await this.$http.post(this,'/coupon/checkCouponInfo', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getAllList(0);
					    }
          }
      },
      async showHot(){
          let currentSelect = this.$refs.allTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.hotFlag = 1;
              let result = await this.$http.post(this,'/coupon/setCouponHotFlag', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getAllList(0);
					    }
          }
      },
      async hideHot(){
          let currentSelect = this.$refs.allTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.hotFlag = 0;
              let result = await this.$http.post(this,'/coupon/setCouponHotFlag', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getAllList(0);
					    }
          }
      },
      async examineAudit(){
          let currentSelect = this.$refs.examineTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.checkStatus = 3;
              let result = await this.$http.post(this,'/coupon/checkCouponInfo', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getExamineList(0);
					    }
          }
      },
      async examineFailAudit(){
          let currentSelect = this.$refs.examineTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.checkStatus = 2;
              let result = await this.$http.post(this,'/coupon/checkCouponInfo', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getExamineList(0);
					    }
          }
      },
      async truShowHot(){
          let currentSelect = this.$refs.truTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.hotFlag = 1;
              let result = await this.$http.post(this,'/coupon/setCouponHotFlag', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getTruList(0);
					    }
          }
      },
      async truHideHot(){
          let currentSelect = this.$refs.truTable.selection;
          if(currentSelect.length ==0){
            	this.$message({
                type: "error",
                message: '请选择卡券！'
						  })
              return;
          } else {
              let couponList = [];
              for (var i=0; i < currentSelect.length; i++) {
                  couponList.push(currentSelect[i].couponId);
              }
              let condition={};
              condition.idList = couponList;
              condition.hotFlag = 0;
              let result = await this.$http.post(this,'/coupon/setCouponHotFlag', {},condition);
              if (result && result.code == 200) {
                  	this.$message({
                      message: '修改卡券成功！',
                      type: "success"
                    });
                    this.getTruList(0);
					    }
          }

      },
      getList(index){
        this.getAllFilterList();
        this.getExamineFilterList();
        this.getTruFilterList();
      }
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;
  }


  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
</style>
